import { createStore } from 'vuex'

export default createStore({
    state: {
        urlParams: {},//URL的参数
        childInfo: {},//成员信息
        isVip:false,
        todayTask:[],
        dcb_list:[], //单词本数组
        select_task:{},
        select_dcb:{}//选中的单词本
    },
    mutations: {
        updateUrlParams(state,data){
            state.updateUrlParams = data
        },
        updateChildInfo(state,data){
            state.childInfo = data
        },
        updateIsVip(state,data){
            state.isVip = data
        },
        updateTodayTask(state,data){
            state.todayTask = data
        },
        updateDcbList(state,data){
            state.dcb_list = data
        },
        updateSelectTask(state,data){
            state.select_task = data
        },
        updateSelectDcb(state,data){
            state.select_dcb = data
        }
    },
    actions: {

    },
    getters: {

    }
})